
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { EncryptionService } from '../services/encryption.service';

@Injectable()
export class DecryptionInterceptor implements HttpInterceptor {
  
  constructor(private encryptionService: EncryptionService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse && event.body?.encrypted === true) {
          try {
            const decryptedData = this.encryptionService.decryptData(event.body.data);
            return event.clone({
              body: decryptedData
            });
          } catch (error) {
            
            throw new HttpErrorResponse({
              error: 'Lỗi giải mã dữ liệu',
              status: 500,
              statusText: 'Decryption Error'
            });
          }
        }
        return event;
      }),
      catchError(error => {
        console.error('Lỗi trong interceptor:', error);
        return throwError(error);
      })
    );
  }
}